import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { registerUser } from '../../api/client';

export function Register() {
  const [username, setUsername] = useState('');
  const [name, setName] = useState('');
  const [notificationEmail, setNotificationEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      await registerUser({
        username,
        password,
        name,
        notification_email: notificationEmail,
      });
      setSuccess(true);
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'system-ui',
        background: '#f5f5f5'
      }}>
        <div style={{
          width: '400px',
          background: '#fff',
          padding: '32px',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          textAlign: 'center'
        }}>
          <div style={{
            width: '64px',
            height: '64px',
            background: '#d4edda',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
            fontSize: '32px',
            color: '#155724'
          }}>
            ✓
          </div>
          <h1 style={{ marginBottom: '16px', fontSize: '24px' }}>Registration Submitted</h1>
          <p style={{ color: '#666', marginBottom: '24px', lineHeight: '1.5' }}>
            Your account is pending approval. You'll be able to login once an administrator approves your request.
          </p>
          <button
            onClick={() => navigate('/admin/login')}
            style={{
              padding: '12px 24px',
              cursor: 'pointer',
              background: '#007bff',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'system-ui',
      background: '#f5f5f5'
    }}>
      <form onSubmit={handleSubmit} style={{
        width: '400px',
        background: '#fff',
        padding: '32px',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ marginBottom: '8px', fontSize: '24px' }}>Request Access</h1>
        <p style={{ marginBottom: '24px', color: '#666' }}>
          Fill out the form below to request access to ConstMGR.
        </p>

        {error && (
          <div style={{
            color: '#dc3545',
            background: '#f8d7da',
            padding: '12px',
            borderRadius: '4px',
            marginBottom: '16px'
          }}>
            {error}
          </div>
        )}

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Your full name"
            style={{ width: '100%', padding: '10px', boxSizing: 'border-box', fontSize: '16px' }}
            required
            autoFocus
          />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Username</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Choose a username"
            style={{ width: '100%', padding: '10px', boxSizing: 'border-box', fontSize: '16px' }}
            required
          />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Email</label>
          <input
            type="email"
            value={notificationEmail}
            onChange={(e) => setNotificationEmail(e.target.value)}
            placeholder="your@email.com"
            style={{ width: '100%', padding: '10px', boxSizing: 'border-box', fontSize: '16px' }}
            required
          />
          <small style={{ color: '#666' }}>For notifications and account recovery</small>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: '100%', padding: '10px', boxSizing: 'border-box', fontSize: '16px' }}
            required
            minLength={6}
          />
          <small style={{ color: '#666' }}>Minimum 6 characters</small>
        </div>

        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Confirm Password</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={{ width: '100%', padding: '10px', boxSizing: 'border-box', fontSize: '16px' }}
            required
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: '12px',
            cursor: loading ? 'not-allowed' : 'pointer',
            background: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            fontWeight: 'bold',
            opacity: loading ? 0.7 : 1,
            marginBottom: '16px'
          }}
        >
          {loading ? 'Submitting...' : 'Request Access'}
        </button>

        <p style={{ textAlign: 'center', margin: 0 }}>
          Already have an account?{' '}
          <Link to="/admin/login" style={{ color: '#007bff' }}>Login</Link>
        </p>
      </form>
    </div>
  );
}
